<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <h1>Video Sermons</h1>
          <h2 class="h1">Jerry's Uploads</h2>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="px-5">
        <video-list
          playlistId="PL4i1fmTD7kZVLuAw2gzwOrncw5X8zLSu_"
          playlistTitle="Jerry's Uploads"
        />
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import VueYouTubeEmbed from "vue-youtube-embed";
import VideoList from "../components/VideoList.vue";

Vue.use(VueYouTubeEmbed);

export default {
  components: {
    VideoList
  },
  metaInfo:{
    title: 'Faith Christian Church Evansville: Sermon Video Archive',
    description: 'Look past sermons recorded on YouTube from Pastor Jerry Dean',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
};
</script>